import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import { useUpdateRuleRulesIdPatchMutation } from "api";
import { IRule } from "interfaces/rules.interface";

type ToggleRuleDialogProps = {
  rule?: IRule;
  onClose: () => void;
};

export function ToggleRuleDialog({ rule, onClose }: ToggleRuleDialogProps) {
  const { t } = useTranslation();

  const [updateRule] = useUpdateRuleRulesIdPatchMutation();

  return (
    <Dialog open={!!rule} onClose={onClose}>
      <DialogTitle>
        {rule?.enabled
          ? t("disable_notification_rule")
          : t("enable_notification_rule")}
      </DialogTitle>
      <DialogContent dividers>
        {rule?.enabled
          ? `${t("are_you_sure_you_want_to_disable_this_rule")}`
          : `${t("are_you_sure_you_want_to_enable_this_rule")}`}
      </DialogContent>
      <DialogActions>
        <Button variant={"text"} onClick={onClose}>
          {t("Cancel")}
        </Button>
        <Button
          color={rule?.enabled ? "warning" : "primary"}
          onClick={async () => {
            if (rule) {
              await updateRule({
                id: rule.id,
                ruleUpdateModels: {
                  type: rule.type,
                  enabled: !rule.enabled,
                },
              });
            }

            onClose();
          }}
        >
          {rule?.enabled ? t("Yes_disable_it") : t("Yes_enable_it")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
